export const PERSONAL_ITEM = {
  name: 'personalItem'
};
//# sourceMappingURL=constants.js.map